module.exports = __webpack_public_path__ + "img/Dantam Bridal 02.012d2da3.jpg";